import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import '../assets/css/icon.scss';
let IconMixin = class IconMixin extends Vue {
  constructor() {
    super(...arguments);
    this.iconClass = '';
    this.remoteUrl = '';
  }
  changeName(v) {
    var _this$lowcode;
    if (this.iconType == 'custom' && (v.includes('remoteUrl') || v.startsWith('http'))) {
      // 兼容先前
      if (v.includes('remoteUrl')) {
        let {
          iconClass = '',
          remoteUrl = ''
        } = JSON.parse(v);
        this.iconClass = iconClass;
        this.remoteUrl = remoteUrl;
      } else {
        let index = v.lastIndexOf('/');
        this.remoteUrl = v.substr(0, index);
        this.iconClass = v.substr(index + 1).split('.')[0];
      }
    } else {
      this.iconClass = v;
      this.remoteUrl = '';
    }
    if (this.remoteUrl && (_this$lowcode = this['lowcode']) !== null && _this$lowcode !== void 0 && (_this$lowcode = _this$lowcode.utils) !== null && _this$lowcode !== void 0 && _this$lowcode.url2cdn) this.remoteUrl = this['lowcode'].utils.url2cdn(this.remoteUrl);
  }
  get style() {
    return {
      color: this.color,
      fontSize: this.size
    };
  }
};
__decorate([Prop({
  default: 'platform-eleme'
})], IconMixin.prototype, "name", void 0);
__decorate([Prop({
  default: 'default'
})], IconMixin.prototype, "iconType", void 0);
__decorate([Prop({
  default: '24px'
})], IconMixin.prototype, "size", void 0);
__decorate([Prop()], IconMixin.prototype, "color", void 0);
__decorate([Watch('name', {
  immediate: true
})], IconMixin.prototype, "changeName", null);
IconMixin = __decorate([Component({
  name: 'IconMixin'
})], IconMixin);
export default IconMixin;